module.exports = __webpack_public_path__ + "img/arrow-circle-down.4e9f3267.svg";